import emailjs from '@emailjs/browser';

/** Brochure page template; falls back to the demo template when unset. */
export function getPodscopeBrochureContactTemplateId(): string {
    return (
        process.env.REACT_APP_EMAILJS_PODSCOPE_BROCHURE_TEMPLATE_ID ||
        process.env.REACT_APP_EMAILJS_DEMO_TEMPLATE_ID ||
        ''
    );
}

export type ContactEmailParams = {
    name: string;
    email: string;
    message: string;
    firstName?: string;
    lastName?: string;
    company?: string;
    /** Job title / cargo en la empresa */
    role?: string;
    /** Email subject line (use `{{subject}}` in the EmailJS template Subject field). */
    subject?: string;
    /** Defaults to `REACT_APP_EMAILJS_DEMO_TEMPLATE_ID`. */
    templateId?: string;
};

/**
 * Sends via EmailJS. Template variables available:
 * - `{{subject}}` — put this in the EmailJS Subject field
 * - `{{user_name}}` — full name
 * - `{{user_first_name}}`
 * - `{{user_last_name}}`
 * - `{{user_email}}`
 * - `{{company}}`
 * - `{{role}}` / `{{job_title}}` — same cargo value
 * - `{{message}}`
 */
export async function sendContactEmail(params: ContactEmailParams): Promise<void> {
    const templateId = params.templateId ?? process.env.REACT_APP_EMAILJS_DEMO_TEMPLATE_ID ?? '';
    const firstName = params.firstName?.trim() || '';
    const lastName = params.lastName?.trim() || '';
    const fullName = params.name.trim() || [firstName, lastName].filter(Boolean).join(' ') || '';
    const company = params.company?.trim() || '';
    const role = params.role?.trim() || '';
    const subject =
        params.subject?.trim() ||
        (company ? `Solicitud Podscope de ${company}` : 'Solicitud Podscope');

    await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID ?? '',
        templateId,
        {
            subject,
            user_name: fullName,
            user_first_name: firstName,
            user_last_name: lastName,
            user_email: params.email,
            company,
            role,
            job_title: role,
            message: params.message,
        },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY ?? ''
    );
}
